import { Tooltip } from "bootstrap";

export const vTooltip = {
  mounted: (el) => new Tooltip(el),
};
